export const scrollToElement = (selector, offset, smooth = true) => {
    const target = document.querySelector(selector);
    if (!target) return;
    const options = {
        top: target.offsetTop + offset,
        behavior: smooth ? 'smooth' : 'auto',
    };

    window.scrollTo(options);
};
